import { useAtomValue } from 'jotai';
import { organizationDataAtom, googleAdsAccountAtom } from '@/store';
import getSymbolFromCurrency from 'currency-symbol-map';

/**
 * Returns the currency code and symbol for display.
 *
 * @param source - Where to read currency from:
 *   - `'org'` (default): org.default_currency — for budgets, inputs, user-set values
 *   - `'google'`: googleAdsAccount.currency — for Google Ads performance data (spend, CPC, ROAS)
 * @param _currency - Optional override that takes precedence over both sources
 */
export function useCurrencySymbol(source: 'org' | 'google' = 'org', _currency?: string) {
  const organizationData = useAtomValue(organizationDataAtom);
  const googleAdsAccount = useAtomValue(googleAdsAccountAtom);

  const sourceCurrency = source === 'google'
    ? googleAdsAccount?.currency
    : organizationData?.default_currency;

  const currency = _currency ?? sourceCurrency ?? 'EUR';
  const symbol = getSymbolFromCurrency(currency) ?? '€';

  return { currency, symbol };
}
